function objectToOption(object, indexes) {
  if (!object || (typeof object === "object" && object.id == null)) {
    return { label: "", value: "", object: null };
  }
  const label =
    indexes
      .filter((i) => object[i])
      .map((i) => object[i])
      .join(" - ") ||
    object.id ||
    "";
  return {
    label: String(label),
    value: object.id,
    object: object,
  };
}

export default objectToOption;
